import { Stack } from '@chakra-ui/react'

import assertDefined from '@/utils/assertDefined'

import { useUser } from '@/client/context/user'

import FileUploadGallery from '@/components/Worlds/FileUpload/FileUploadGallery'

import type { PostContentsProps } from '../types'
import PostBody from './PostBody'
import PostFooter from './PostFooter'
import PostHeader from './PostHeader'

export default function PostContentsUserPost({
  post,
  showCommentButton = false,
  truncateIfLong = false,
  showMenuOnGroupHover = false,
  hideFullViewMenuItem = false,
  preview = false,
  onEdit,
  onDelete,
  onReport,
}: PostContentsProps): JSX.Element {
  const { attachments, body } = post
  const currentUser = useUser()

  assertDefined(body, `Post#${post.id} has no body, which is expected for type 'user-post'`)

  return (
    <Stack direction="column" spacing="18px" role="group">
      <PostHeader
        post={post}
        onEdit={onEdit}
        onDelete={onDelete}
        onReport={onReport}
        showMenuOnGroupHover={showMenuOnGroupHover}
        hideFullViewMenuItem={hideFullViewMenuItem}
        hideMenu={preview}
      />
      <Stack direction="column" spacing="24px">
        <PostBody
          body={body}
          truncateIfLong={truncateIfLong}
          truncationMessage={preview ? '...' : 'See more'}
        />
        <FileUploadGallery uploads={attachments} />
        {preview ? null : (
          <PostFooter
            post={post}
            showCommentButton={showCommentButton}
            showPostStatusSection={currentUser != null && currentUser.id === post.user.id}
          />
        )}
      </Stack>
    </Stack>
  )
}
